import { recordScriptOpened } from '@/api/scripts'
import { TOKEN_KEY } from '@/config/constants'
import { activeWorkspaceTool } from './navigation'
import { routeScriptId } from './scriptSelection'

// Track entering a tool, including direct URLs and returning to a cached page.
// List refreshes, polling and query-only UI changes never pass this boundary.
export function startScriptLoadActivity(router, browser = window) {
  const context = route => {
    const tool = activeWorkspaceTool(route) || (route.name === 'ScriptAssetGenerate' ? 'script-assets' : '')
    const scriptId = routeScriptId(route)
    return tool && /^\d+$/.test(scriptId) && Number(scriptId) > 0 ? { tool, scriptId } : null
  }
  return router.afterEach((to, from, failure) => {
    if (failure) return
    const next = context(to)
    const previous = context(from)
    if (!next || (next.tool === previous?.tool && next.scriptId === previous.scriptId)) return
    const token = browser.localStorage.getItem(TOKEN_KEY)
    if (!token) return
    // Ordering must not prevent the tool itself from opening if the request fails.
    void recordScriptOpened(next.scriptId, { expectedAuthToken: token }).catch(() => {})
  })
}
